export const getGraphQLErrorMessage = (graphQLBackendError) => {
  return graphQLBackendError?.graphQLErrors?.[0]?.message;
};
